const INPI_STATUS = {
    init: 'init',
    offline: 'offline',
    online: 'online'
};

export { INPI_STATUS };
